// @ts-nocheck
import React from "react";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-scroll";

//ヘッダー
import Header from "../../component/page_parts/header";

// フッター
import Footer from "../../component/page_parts/footer";

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// パンくずリスト
import TableOfContents from "../../component/page_parts/common/table_of_contents";

function JinjiLifestyle() {
  const [explanationChangeValue, setExplanationChangeValue] =
    useState<string>("1");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // GAID
  const gaId = process.env.REACT_APP_GA_ID;

  var element = document.getElementById("1");
  var userName = localStorage.getItem("user_name");
  ReactGA.initialize(gaId);
  ReactGA.send({
    hitType: "event",
    eventCategory: userName,
    eventAction: '人事ガイド-タブ切り替え',
    eventLabel: element?.textContent,
  });

  const selectCategory = (value) => (e) => {
    setExplanationChangeValue(value);

    //全てのbtnToggleのis-activeを外す
    const btnToggleAll = document.querySelectorAll(".btnToggle");
    btnToggleAll.forEach((btnToggle) => {
      btnToggle.classList.remove("is-active");
    });

    //クリックしたbtnToggleにis-activeを付与
    const btnToggle = document.getElementById(value);
    btnToggle.classList.add("is-active");

    // GA4タブ押下時計測
    var element = document.getElementById(e.target.id);
    var userName = localStorage.getItem("user_name");
    console.log(element?.textContent);
    ReactGA.initialize(gaId);
    ReactGA.send({
      hitType: "event",
      eventCategory: userName,
      eventAction: '人事手続き-タブ切り替え',
      eventLabel: element?.textContent,
    });
  };

  //テスト環境
  const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';

  return (
    <>
      <Helmet>
        <title>Z-link 人事ガイド</title>
      </Helmet>
      <Header />
      <div className="theme-jinji-lifestyle">
        <div className="content-header">
          <div className="container pe-4">
            <Row>
              <Col sm={9} >
                <h1 className='page-title type-human'>人事ガイド</h1>{/* ページタイトル */}
                <p className="page-description pt-1">日々の働き方や様々なライフイベントにまつわる人事関連情報や手続きをご案内します。</p>{/* ページの説明 */}
              </Col>
              <Col sm={3} className="d-flex align-bottom align-self-center mb-4">
                <div className="jinji-related">
                  <div className="page-title-area">
                    <button className="btn-link-area py-3">
                      <a href={baseUrl + '/lifestyle/evaluation'}>人事評価制度について</a>
                    </button>
                  </div >
                </div >
              </Col >
            </Row >
          </div >
        </div >
      </div >
      <TableOfContents />
      < div className="main-wrapper jinji-related theme-jinji-lifestyle" >
        <div className="contents-wrap mt-5 container">
          <div className="d-flex flex-wrap justify-content-between mt-5 select-tags">
            <div
              className="tag flex-fill px-2 btnToggle is-active"
              id="1"
              onClick={selectCategory("1")}
            >
              働き方
            </div>
            <div
              className="tag flex-fill px-2 btnToggle"
              id="2"
              onClick={selectCategory("2")}
            >
              ライフイベント・手続き
            </div>
            <div
              className="tag flex-fill px-2 btnToggle"
              id="3"
              onClick={selectCategory("3")}
            >
              人事・勤怠システム
            </div>
            <div
              className="tag flex-fill px-2 btnToggle"
              id="4"
              onClick={selectCategory("4")}
            >
              ヘルスケア
            </div>
          </div>

          {/* 働き方 */}
          {explanationChangeValue === "1" ? (
            <div className="contentOne">
              <h2 className="tag-title">働き方</h2>
              <Row className="toc-btnArea first-row">
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter01"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    オフィス勤務
                  </Link>
                </Col>
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter02"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    在宅勤務
                  </Link>
                </Col>
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter03"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    時差出勤
                  </Link>
                </Col>
              </Row>
              <Row className="toc-btnArea">
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter04"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    ゆとり出社・退社
                  </Link>
                </Col>
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter05"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    残業
                  </Link>
                </Col>
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter06"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    休暇
                  </Link>
                </Col>
              </Row>
              {/* オフィス勤務 */}
              <h3 className="icon-title type-pencil" id="chapter01">オフィス勤務</h3>
              <h4 className="bg-title mt-small">打刻方法</h4>
              <div className="border-box">
                <p className="todo-catch"><span>To Do</span>出勤・退勤する際には、必ず打刻をしましょう
                </p>
                <div>・勤怠管理は、ジンジャーというシステムで行います。<br />
                  <p className='document-leadText'>出退勤打刻のやり方は
                    <a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900002011046" target="_blank" rel="noopener noreferrer" className='text-link type-external'>こちら</a></p></div>
              </div>


              <div className="border-box">
                <div className="todo-list mb-2">
                  <span className="attention-point">注意点</span>
                </div>
                <div>・必ず、実際の出退勤時刻を登録しましょう。<br />
                  <p>→始業時刻の30分前から・終業時刻の30分後までの間に打刻できます。<br />※上記の時間以外に打刻をする場合には「ゆとり出社」「ゆとり退社」の文言をコメントに残し、出退勤ボタンを押しましょう<br />打刻方法でわからないことがあれば<a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900002011046" className='text-link type-external' target="_blank">こちら</a></p>
                </div>
              </div>
              {/* 在宅勤務（リモートワーク） */}
              <h3 className="icon-title type-pencil" id="chapter02">在宅勤務（リモートワーク）</h3>
              <h4 className="bg-title mt-small">在宅勤務制度</h4>
              <p>在宅勤務（リモートワーク）は、自宅で業務を行うワークスタイルです。<br />Zenkenでは、2つの在宅勤務の方法を設けています。</p>
              <div className="committee-related">
                <div className="point-list-border no-title mb-3">
                  <ul className="dot-list type-list">
                    <li>通常リモートワーク：出社頻度週１回以下のリモートワーク（原則在宅）</li>
                    <li>臨時リモートワーク：通常リモートワーク以外で実施するリモートワーク（原則出社）</li>
                  </ul>
                </div>
                <p>※リモートワークに当たり、特別な手当はありません。<br />※みなし残業代支給の社員は1日のみなし残業時間（1時間）を超える残業はNG。また、残業前に
                  ジンジャーにて残業申請を必ず行ってください。みなし残業代が支給されていない社員は残業自体NG。</p>
                <p>通常・臨時どちらのパターンでも共通して、<br />年に1回 全社員の皆さんに「<a href='https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=cab47ca740074ce995435aaab1e5aa36' className='text-link type-external' target='_blank'>リモートワーク誓約書</a>」をご提出いただきます。<br />※提出時期になりましたら改めてお知らせいたしますが、未提出の方は上記よりご対応ください。</p>




                <h4 className="bg-title mt-small">通常リモートワーク</h4>
                <p>通常リモートは「出社頻度週１回以下のリモートワーク」を指します。<br />通常リモートの方には、定期代を支給せず、<br />当月の出社日数実績に応じてIC料金で計算した通勤費を翌月の給与と共に支給します。</p>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>通常リモートの申請について
                  </div>
                  <ol>
                    <li>通常リモートワークは、上長（マネジャー以上）との面談※が必須です。
                      <br />※上長面談には部署により一定の基準がありますので、上長にご確認ください。</li>
                    <li>タレントパレットより、「<a href='https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=52caa8218e424ddab00eef849e07fb23' className='text-link type-external' target='_blank'>通常リモートワーク申請</a>」をお願いいたします。1回の申請で、最長3か月間の通常リモートワークを行うことが可能です。<br />⚠️申請にあたってのお願い⚠️<br />・「10日までに承認完了」するようにご対応ください。<br />・3ヶ月更新の原則はお守りいただき、更新・終了する場合は必ず3ヶ月目に更新の申請を行ってください。<br />（例）6月から新規で通常リモートワークをしたい場合、5月10日までに承認完了している必要があります。更新申請は8月10日までに、「9月・10月・11月分の申請」について承認が完了している必要があります。
                    </li>
                    <li>jinjerの「スケジュール申請」にて「リモ」と付いたテンプレートで申請をお願いいたします。</li>
                    <li>承認後、リモートワークへ。jinjerの「打刻区分：リモートワーク」で打刻してください。</li>
                  </ol>
                  <p>＜通常リモートワークを継続する場合※＞<br />※生産性低下等の上長判断により、継続不可となることもあります。<br />
                    ・「10日までに承認完了」するように更新の申請を行ってください。<br />・3ヶ月更新の原則はお守りいただき、必ず3ヶ月目に更新の申請を行ってください。<br />（例）6月から新規で通常リモートワークをしたい場合、5月10日までに承認完了している必要があります。更新申請は8月10日までに、「9月・10月・11月分の申請」について承認が完了している必要があります。
                    <br />必ず下記の規定を確認してから申請してください。</p>
                  <Row className="mt-5">
                    <Col sm={6}>
                      <a
                        href="https://sites.google.com/zenken.co.jp/contracts-regulations/regulations/regulations_related_to_personnel_and_labor_affairs/Telecommuting-Regulations?authuser=0"
                        target="_blank"
                        className="btn main-btn type-external"
                      >
                        在宅勤務規程
                      </a>
                    </Col>
                  </Row>
                  <p>＜通常リモートワークを終了する場合＞<br />・通常リモートワークを終了される場合には必ず「<a href="https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=a589b57fc8cd43159b335c1921127611" target="_blank" rel="noopener noreferrer" className='text-link type-external'>通常リモートワーク終了申請</a>」を行ってください。<br />・翌月の通常リモートワーク終了申請は、「10日までに承認完了」するようにご対応ください。</p>

                </div>

                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>リモートワーク出退勤時の必須事項
                  </div>
                  <p className="type-list">
                    出社と区別をするために、jinjerでの打刻時に、「打刻区分：リモートワーク」に必ずチェックを入れて出勤、退勤打刻を行ってください。
                  </p>
                  <p>通常リモート勤務の場合、「打刻区分：リモートワーク」の打刻実績により通勤手当が計算されます。打刻実績が誤っていた場合、通勤手当の誤支給となるのでご注意ください。</p>
                  <p>もし「打刻区分を間違えていた！」というときは、打刻修正申請をお願いします。<br />下記マニュアルをご参照ください。</p>
                  <Row className="mt-5">
                    <Col sm={6}>
                      <a
                        href="https://www.ztree.cfbx.jp/info-wp/wp-content/uploads/2024/03/%E5%9C%A8%E5%AE%85%E5%8B%A4%E5%8B%99%E5%8C%BA%E5%88%86%E9%81%8B%E7%94%A8%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB.pdf"
                        target="_blank"
                        className="btn main-btn type-external"
                      >
                        在宅勤務区分運用マニュアル
                      </a>
                    </Col>
                  </Row>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>リモートワーク時の通勤費について
                  </div>
                  <p className="type-list">
                    実費支給 （上限1日3,000円）※現時点で1日3,000円超過の社員は変更なし。
                  </p>
                </div>
                <h4 className="bg-title mt-small">臨時リモートワーク</h4>
                <p>臨時リモートは、通常リモート以外で実施するリモートワーク（原則出社）です。
                </p>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>臨時リモートの申請について
                  </div>
                  <ol>
                    <li>jinjerの「スケジュール申請」より、「リモ」と追加テンプレートで申請をお願いいたします。
                    </li>
                    <li>承認後、リモートワークへ。jinjerの「打刻区分：リモートワーク」で打刻してください。
                    </li>
                  </ol>
                  <p>※通常出勤と区別をするために、ジンジャーでの打刻時に、打刻区分で「在宅勤務」に必ずチェックを入れて出勤、退勤打刻を行ってください。</p>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>リモートワーク時の通勤費について
                  </div>
                  <p className="type-list">
                    定期代支給 （1ケ月の半数以上がリモートワークの場合、定期代の返金を求める場合あり）
                  </p>
                </div>
              </div>
              <h3 className="icon-title type-pencil" id="chapter03">時差出勤</h3>
              <h4 className="bg-title mt-small">時差出勤（スライドワーク）</h4>
              <h5 className="icon-title mt-small">時差出勤制度</h5>
              <div className="committee-related">
                <div className="point-list-border no-title mb-3">
                  <p>時差出勤（スライドワーク）とは、勤務時間の総時間数を変えず、始業時間を変更する勤務形態です。スライドワークを活用することで、個々の業務やプライベートの都合に合わせて、柔軟な働き方が可能になります。</p>
                  <ul className="dot-list type-list">
                    <li>事前の上長承認が必要です。計画的に活用しましょう！</li>
                    <li>対象者は、所定時間７時間40分の「正社員」「契約社員」です。</li>
                  </ul>
                  <p>事業部ごとの、選択可能な始業時間は下記資料をご確認ください。</p>
                  <iframe
                    src="https://www.ztree.cfbx.jp/info-wp/wp-content/uploads/2024/09/【確定】勤務制度の変更案内（人事部）_240927.pdf"
                    width="100%"
                    height="450px"
                    title="PDF Viewer"
                    allow="fullscreen"
                  />
                </div>
              </div>
              <div className="committee-related">
                <h5 className='icon-title mt-small'>申請方法</h5>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>ジンジャー申請方法
                  </div>
                  <p>ジンジャーで事前申請し、上長の承認で勤務時間を変更できます。原則として、水曜までに翌週の申請を実施してください。</p>
                </div>
              </div>
              <h5 className='icon-title mt-small'>申請の注意点</h5>
              <div className="committee-related">
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>部署ごとに決まっているスライドワークの範囲で申請してください
                  </div>
                  <p>自部署のスライドワーク範囲が①～⑥の場合でも、⑦を選択して申請することができます。
                    上長が否認しますが、間違った申請をしないように気をつけてください！</p>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>スライドワークと「半休」や「時間有給」を組み合わせる場合は
                    スライドワークの上長承認を確認してから、「半休」「時間有給」を申請してください
                  </div>
                  <ul className="dot-list type-list">
                    <li>スライドワーク予定日に既に半休/時間有給を申請している場合
                      →半休/時間休の申請取下げ（承認済の場合は上長に「否認」をお願い）が最優先
                      ⇒手順を間違えるとお給料が減ってしまう場合があります・・・！締め前に確認する癖をつけましょう！
                    </li>
                  </ul>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>入社1年以上の社員には、執務室のセキュリティ権限を持っていただきます
                    執務室は最初に出社した社員が解錠し最後に退出する社員が施錠してください
                  </div>
                  <ul className="dot-list type-list">
                    <li>管理監督者（SM以上）がいない場合は、22時までに最終退社しましょう！</li>
                    <li>セキュリティ権限の付与は年2回です。（7/1・1/1時点で在籍1年以上の社員）</li>
                  </ul>
                </div>
                <h5 className="icon-title mt-small">打刻、残業申請の注意点</h5>
                <p>スライドワークとともに、勤怠報告の見直しをお願いします。</p>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>打刻と残業申請は、働いた時間通りに実施してください
                  </div>
                  <ul className="dot-list type-list">
                    <li>みなし残業の範囲内であっても、働いた時間通りに打刻をして、残業申請をお願いします。</li>
                    <li>「みなし残業の範囲内だから定時で打刻しておこう。残業申請も省略しよう。」はNGです。</li>
                  </ul>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>残業申請は、終業時間の２時間前までを目安に上長承認を得るようにしてください
                  </div>
                  ※「終業時間の１時間前の夕礼で承認」などの運用をしているチームは、そちらを優先してかまいません。
                </div>
                <h5 className="icon-title mt-small">承認の注意点（ジンジャー承認者）</h5>
                <div className="committee-related">
                  <div className="point-list-border mb-3">
                    <div className="point-title">
                      <span>To Do</span>部署ごとに決められているスライドワークの範囲で承認
                    </div>
                    <ul className="dot-list type-list">
                      <li>システムガードはかけていません。</li>
                    </ul>
                    <p>自部署が認めていない始業時間でも申請ができてしまいます<br />承認前に確認をお願いします。</p>
                  </div>
                  <div className="point-list-border mb-3">
                    <div className="point-title">
                      <span>CHECK</span>「半休」「時間有給」を承認している日にスライドワーク申請があったら
                    </div>
                    <ul className="dot-list type-list">
                      <li>「半休/時間有給」を一度否認してから、スライドワークを承認</li>
                      <li>その上で必要に応じて「半休/時間休」を再申請するよう本人にコミュニケーションしてください
                        <br />※同時に申請があった場合は「スライドワーク承認」→「半休/時間休承認」の順番で対応
                      </li>
                    </ul>
                    <p>全ての承認は、月次締め前であれば変更可能。最終確認をお願いいたします！</p>
                  </div>
                </div>
              </div>
              <h3 className="icon-title type-pencil" id="chapter04">ゆとり出社・退社</h3>
              <h4 className="bg-title mt-small">ゆとり出社・退社</h4>
              <p>※管理監督者は入力不要です</p>
              <p>実打刻と出退勤時間に30分以上の差異が発生する場合にはジンジャー打刻時のコメント欄に「ゆとり出社」・「ゆとり退社」の入力が必須となります！</p>
              <div className="committee-related">
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>「ゆとり出社」が必要なケース
                  </div>
                  <p>⇒始業時間より30分以上の差異がある場合。<br />例）10：00始業／9：29分以前に打刻</p>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>「ゆとり退社」が必要なケース
                  </div>
                  <p>⇒定時時間、または残業申請時間より30分以上の差異がある場合。<br />例１）残業なし　18：40定時／19：11以降に打刻<br />例２）残業あり　20：10まで残業申請／20：41以降に打刻<br />（※なお、申請時間以降も残業が継続となっている場合は、追加で残業申請を行ってください）<br />適切な労務管理の観点から、皆さまにご対応いただきますようお願いいたします。</p>
                </div>
              </div>
              <h4 className="bg-title mt-small">処理方法</h4>
              <div className="committee-related">
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>ゆとり出社・退社の処理方法
                  </div>
                  <p>2月1日の打刻より、必ず①⇒②の順番に処理をお願いします。<br />①勤怠TOPページのコメント欄に「ゆとり出社」または「ゆとり退社」と入力<br />（乖離時間の記載は不要です）<br />②「出勤」・「直行」・「退勤」・「直帰」の該当する打刻をクリック（※以下画像参照）<br />※打刻ボタンを押した後では、コメント欄への入力ができませんので、ご注意ください。<br />※入力できなかった場合は、「打刻修正申請」の「打刻修正理由」欄に「ゆとり出社（または退社）」と入力の上、申請をお願いいたします。</p>
                </div>
              </div>
              <div className="img-wrap ct">
                <div className="flame">
                  <img
                    src={process.env.PUBLIC_URL + '/jinji_pic/margin-attendance.png'}
                    alt="ゆとり出社の打刻コメント"
                    className="img-wrap__img"
                  />
                </div>
              </div>

              {/* 残業 */}
              <h3 className="icon-title type-pencil" id="chapter05">残業</h3>
              <h4 className="bg-title mt-small">取得ルール</h4>
              <p>労働基準法では、１日の労働時間を８時間以内、１週間の労働時間を40時間以内と定めています。<br />この法定労働時間を超えて社員の皆さんに働いていただくことがありますので、あらかじめ従業員の過半数代表者との間に、「時間外労働・休日労働に関する協定」を締結し、労働基準監督署に届け出ています。<br />※この協定は「36（サブロク）協定」と呼ばれています</p>
              <p>皆さんの健康のためにも、できるだけ残業をせずとも帰宅できるよう、日頃から業務効率を高める工夫をしましょう！<br />業務上、必要な場合には、必ず事前に申請をしてから残業を行うようにしましょう。</p>
              <h4 className="bg-title mt-small">申請方法</h4>
              <div className="committee-related">
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>To Do</span>通常時の残業申請
                  </div>
                  <p>上長と相談の上、ジンジャーにて申請してください。</p>
                  <p>申請方法は<a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900002012283" target="_blank" rel="noopener noreferrer" className='text-link type-external'>こちら</a>よりご確認ください。</p>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>36協定特別条項適用の申請
                  </div>
                  <p>１日８時間・週40時間を超えて働く場合や休日労働をする場合に関する従業員と会社の取り決めを「36（サブロク）協定」といいます。36協定による当社の残業時間や休日労働の上限は次の通りです。<br />・月45時間（特別条項適用の申請をした場合は75時間まで）<br />・年360時間（特別条項適用申請は年６回＝720時間まで）
                  </p>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>１ヶ月の残業時間・休日労働時間が45時間を超える場合、「特別条項適用申請」をしてください。
                  </div>
                  <p>36協定により、当月の残業時間・休日労働時間が45時間を超える場合、jinjerの残業申請とは別に「特別条項適用申請」が必要です。この申請がないまま月45時間を超えることは問題となりますので、超える可能性が発生した段階で、申請をお願いします（結果的に45時間を超えなかったとしても何ら問題ありません）。<br />引き続き、不要な残業はしないようにしましょう！</p>
                </div>
              </div>
              <h5 className="icon-title mt-small">特別条項適用申請フォーム</h5>
              <p>ご自身の拠点の申請フォームで入力してください。</p>
              <p><a href="https://forms.gle/b61yXPMAAu3LccAG9" target="_blank" rel="noopener noreferrer" className='text-link type-external'>本社</a></p>
              <p><a href="https://forms.gle/QLQaFCwPTshUSpEd9" target="_blank" rel="noopener noreferrer" className='text-link type-external'>留学（全研プラザ）</a></p>
              <p><a href="https://forms.gle/wD49Pa9aWnGGE7zV6" target="_blank" rel="noopener noreferrer" className='text-link type-external'>日本語（プラザⅡ）</a></p>
              <p><a href="https://forms.gle/RW768Da3o8gheXdaA" target="_blank" rel="noopener noreferrer" className='text-link type-external'>大学サポート世田谷</a></p>
              <p><a href="https://forms.gle/JLQLexsF3qem7VBx5" target="_blank" rel="noopener noreferrer" className='text-link type-external'>大学サポート横浜</a></p>
              <p><a href="https://forms.gle/RWj89B9GcVHJzwU88" target="_blank" rel="noopener noreferrer" className='text-link type-external'>名古屋オフィス</a></p>
              <p><a href="https://forms.gle/bGcmLcFDKjUb4Djz5" target="_blank" rel="noopener noreferrer" className='text-link type-external'>大阪オフィス</a></p>
              <p><a href="https://forms.gle/o85hv6sbPgBpnRzy7" target="_blank" rel="noopener noreferrer" className='text-link type-external'>沖縄オフィス</a></p>

              {/* 休暇 */}
              <h3 className="icon-title type-pencil" id="chapter06">休暇</h3>
              <h4 className="bg-title mt-small">種類</h4>

              <h5 className="icon-title mt-small">年次有給休暇</h5>
              <p>取得しても賃金が減額されない休暇です。</p>
              <div className="committee-related">
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>付与日数
                  </div>
                  <p>詳細は<a href="https://sites.google.com/zenken.co.jp/contracts-regulations/regulations/regulations_related_to_personnel_and_labor_affairs/%E6%AD%A3%E7%A4%BE%E5%93%A1%E5%B0%B1%E6%A5%AD%E8%A6%8F%E5%89%87" target="_blank" rel="noopener noreferrer" className='text-link type-external'>正社員就業規則</a>・<a href="https://sites.google.com/zenken.co.jp/contracts-regulations/regulations/regulations_related_to_personnel_and_labor_affairs/%E8%87%A8%E6%99%82%E7%A4%BE%E5%93%A1%E5%B0%B1%E6%A5%AD%E8%A6%8F%E5%89%87" target="_blank" rel="noopener noreferrer" className='text-link type-external'>臨時社員就業規則</a>をご確認ください。</p>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>有給取得義務日数
                  </div>
                  <p>労働基準法では、法定の年次有給休暇日数が10日以上の全ての労働者が、毎年5日間、年次有給休暇を確実に取得することが必要とされています。</p>
                  <p>Zenkenでは、多くの社員の皆さんに有給を付与する 【 4月1日 】 を基準日とし、毎年 【 4月1日～3月31日 】 の間に 【 最低 5日間 】 の有給休暇を取得しているか確認いたします。<br />※基準日時点で入社1年未満の方は、有給取得の義務日数が異なりますのでご注意ください</p>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span className="attention-point">注意点</span>
                  </div>
                  <p>・有給休暇はご自身が希望するタイミングで取得する権利が優先されますが、業務状況によっては、ほかの時季に取得していただくように会社から相談する場合があります。<br />・半休や時間有休を取得する際には、勤務時間に気を付けて申請を行いましょう。<br />・ジンジャーでの有給残日数の確認方法は下記画像を参照してください。</p>
                  <div className="img-wrap ct">
                    <div className="flame">
                      <img
                        src={process.env.PUBLIC_URL + '/jinji_pic/paid-leave-confirmation.png'}
                        alt="有給確認の仕方"
                        className="img-wrap__img"
                      />
                    </div>
                  </div>
                </div>
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span>CHECK</span>取得パターン
                  </div>
                  <p>3パターンございます。<br /><span className="important">①全日有休</span><br /><span className="important">②半休（午前、午後）</span><br />Zenkenの1日の所定労働時間は7時間40分です。
                    半休取得日は「3時間50分」業務をする必要があります。<br />
                  </p>
                  <p>午前半休：終業から3時間50分前を仕事開始としてください。<br />例）10:00～18:40勤務の場合→14:50勤務開始<br />9:30～18:10勤務の場合→14:20勤務開始</p>
                  <p>午後半休：始業から3時間50分後に仕事終わりとしてください。<br />例）10:00～18:40勤務の場合→13:50勤務終了<br />9:30～18:10勤務の場合→13:20勤務終了</p>
                  <p>※原則昼休憩は取得しません。<br />※午後半休の場合、勤務時間を過ぎたら速やかに退勤し、休暇を取りましょう。<br />※時短勤務をされている場合は、7時間40分ではなく、時短後の1日の所定時間を元にします。</p>
                  <p><span className="important">③時間有休（1時間単位）</span><br />子どもの授業参観やちょっとした用事など、1～2時間で終わるようなケースにご活用ください。</p>
                  <p>・1時間単位で有休取得OK<br />・年40時間まで利用可能<br />・遅刻早退時に便利</p>
                </div>

                <h5 className="icon-title mt-small">慶弔休暇</h5>
                <p>① 本人が結婚するとき　５日<br />② 子、兄弟姉妹が結婚するとき　１日<br />③ 父母、配偶者、子の死亡　７日
                  ④ 祖父母、兄弟姉妹、配偶者の父母の死亡　３日<br />⑤ 前項以外の３親等以内の血族又は、２親等以内の姻族の死亡　１日<br />⑥ 妻が出産したとき　１日
                </p>

                <h5 className="icon-title mt-small">産前産後休暇（女性のみ）</h5>
                <p>・産前産後休暇は無給となります。<br />・出産予定日が6週間(多胎児の場合は 14週間)以内に該当する女性社員が休暇を請求した場合は、産前の休暇を取得いただけます。<br />・出産した女性社員には、出産後8週間の産後休暇を取得いただきます。<br />※ただし、産後6週間を経過した女性社員が請求し医師が支障ないと認めた業務に就業することは認めます。</p>


                <h5 className="icon-title mt-small">看護等休暇</h5>
                <p>・看護等休暇は時間単位での取得が可能です。無給のお休みとなります。<br />・小学校3年生までの子を養育する社員から申請のあったとき、1年間につき5日(養育する小学校3年生に達するまでの子が2人以上の場合は 10日)取得いただけます。</p>

                <h5 className="icon-title mt-small">介護休暇</h5>
                <p>・介護休暇は時間単位での取得が可能です。無給のお休みとなります。<br />・1年間につき5営業日(2名以上の要介護者がいる場合は1年につき 10営業日)取得いただけます。</p>



                <h5 className="icon-title mt-small">生理休暇（女性のみ）</h5>
                <p>・生理休暇は1日単位での取得が可能です。無給のお休みとなります。<br />・生理日の就業が著しく困難な女性社員が、休暇を請求した場合に取得いただけます。</p>


                <h5 className="icon-title mt-small">裁判員休暇</h5>
                <p>・裁判員休暇は無給のお休みとなります。<br />・次に挙げるいずれかに該当した場合、裁判員休暇を付与することができます。裁判所から交付される証明書を添付の上、1ヶ月前までに請求しなければなりません。<br />①裁判員候補者として通知を受け、裁判所に出頭したとき。但し、裁判員に選任されなかった場合は、翌日以降取得予定であった本休暇は取り消されるものとし、翌日より勤務しなければならない。また、本号において裁判員等の職務に従事していないにも関わらず出勤しなかったときは、第44条に基づき、無断欠勤として扱う。<br />②補充裁判員を含む裁判員として選任を受け、裁判審理に参加するとき。</p>

              </div>

              <h4 className="bg-title mt-small">申請方法</h4>
              <h5 className="icon-title mt-small">年次有給休暇</h5>
              <p>・全取得パターンとも、ジンジャーの休日休暇申請で申請してください。</p>
              <div className="committee-related">
                <div className="point-list-border mb-3">
                  <div className="point-title">
                    <span className="attention-point">注意点</span>
                  </div>
                  <p>・有給休暇はご自身が希望するタイミングで取得する権利が優先されますが、業務状況によっては、ほかの時季に取得していただくように会社から相談する場合があります。<br />・ジンジャーでの有給残日数の確認方法は下記画像を参照してください。</p>
                  <div className="img-wrap ct">
                    <div className="flame">
                      <img
                        src={process.env.PUBLIC_URL + '/jinji_pic/paid-leave-confirmation.png'}
                        alt="有給確認の仕方"
                        className="img-wrap__img"
                      />
                    </div>
                  </div>
                  <p>・半休や時間有休を取得する際には、勤務時間に気を付けて申請を行いましょう。</p>
                </div>



                <h5 className="icon-title mt-small">慶弔休暇・看護等休暇・介護休暇・生理休暇（女性のみ）</h5>
                <p>・ジンジャーの休日休暇申請で申請してください。</p>

                <h5 className="icon-title mt-small">産前産後休暇（女性のみ）</h5>
                <p>・人事部までご連絡ください。<br />・タレントパレットにて「<a href="https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=d233a174327b4c6d874ae2202e9caee1" target="_blank" rel="noopener noreferrer" className='text-link type-external'>【産前・産後休暇】取得申請</a>」をご提出いただきます。</p>

                <h5 className="icon-title mt-small">裁判員休暇</h5>
                <p>・ジンジャーの休日休暇申請で申請してください。<br />・裁判所から交付される証明書を添付の上、1ヶ月前までに請求しましょう。</p>
              </div>
            </div>
          ) : (
            <></>
          )}
          {/* ライフイベント・手続き */}
          {explanationChangeValue === "2" ? (
            <div className="contentTwo">
              <h2 className="tag-title">ライフイベント・手続き</h2>
              <Row className="toc-btnArea first-row">
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter07"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    年末調整
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter08"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    入社
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter09"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    結婚
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter10"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    出産・子育て
                  </Link>
                </Col>
              </Row>
              <Row className="toc-btnArea first-row">
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter11"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    マイホーム購入
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter12"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    引越し
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter13"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    休職・復職
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter14"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    退職
                  </Link>
                </Col>
              </Row>
              <Row className="toc-btnArea first-row">
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter15"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    家族の就職・退職
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter16"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    介護
                  </Link>
                </Col>
                <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter17"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    身内の不幸
                  </Link>
                </Col>
              </Row>
              {/* 年末調整 */}
              <div className="explanation mx-auto"><div className="contentThree">
                <h3 className="icon-title type-pencil" id="chapter07">年末調整</h3><h4 className="bg-title mt-small">年末調整でやるべきことは？</h4>
                <p id="1" className="contents__qa--question no-acd  content-one-q">PCから年調収集の回答を行うには？</p>
                <p className="contents__qa--answer">こちらからご確認ください。
                  <a href="https://jinjer-jinji.zendesk.com/hc/ja/articles/900004403463" target="_blank" rel="noopener noreferrer" className="text-link type-external">PCにて年調収集の回答を行う</a></p><p id="2" className="contents__qa--question no-acd  content-one-q">スマホから年調収集の回答を行うには？</p><p className="contents__qa--answer">こちらからご確認ください。<a href="https://jinjer-jinji.zendesk.com/hc/ja/articles/10010305042969" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマートフォンにて年調収集の回答を行う</a></p><p id="3" className="contents__qa--question no-acd  content-one-q">添付ファイルをアップロードするには？</p><p className="contents__qa--answer">こちらからご確認ください。<a href="https://jinjer-jinji.zendesk.com/hc/ja/articles/10010808718105" target="_blank" rel="noopener noreferrer" className="text-link type-external">年調収集の回答に必要な画像を添付する</a></p><p id="4" className="contents__qa--question no-acd  content-one-q">回答を中断／再開するには？</p><p className="contents__qa--answer">こちらからご確認ください。<a href="https://jinjer-jinji.zendesk.com/hc/ja/articles/10011917648025" target="_blank" rel="noopener noreferrer" className="text-link type-external">年調収集の回答を中断・再開する方法</a></p><p id="5" className="contents__qa--question no-acd  content-one-q">回答が差し戻されたらどうすればいい？</p><p className="contents__qa--answer">こちらからご確認ください。
                  <a href="https://jinjer-jinji.zendesk.com/hc/ja/articles/4409678405657" target="_blank" rel="noopener noreferrer" className="text-link type-external">年調収集が差し戻された場合の対応方法</a></p><p id="6" className="contents__qa--question no-acd  content-one-q">年調収集の対応状況を確認するには？</p><p className="contents__qa--answer">こちらからご確認ください。<a href="https://jinjer-jinji.zendesk.com/hc/ja/articles/10011332223385" target="_blank" rel="noopener noreferrer" className="text-link type-external">従業員が年調収集の依頼/対応状況を確認する</a></p><h4 className="bg-title">源泉徴収票を確認するには？</h4><p id="1" className="contents__qa--question no-acd  content-two-q">源泉徴収票を確認するには？</p><p className="contents__qa--answer"><a href="https://employee.jinjer.biz/payroll" target="_blank" rel="noopener noreferrer" className="text-link type-external">「こちらの給与明細画面」</a>にログインしてご確認ください。「PDF」は印刷または添付用のデータとなり、画面のみで確認したい場合は「HTML」をクリックしてご確認ください。</p></div></div>
              {/* 入社 */}
              <div className="contentOne"><h3 className="icon-title type-pencil" id="chapter08">入社</h3><h4 className="bg-title mt-small">入社された場合</h4><p className="mb-4">ご入社おめでとうございます。これからZenkenの一員として、ともに励みましょう！</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>入社手続きをお願いいたします</div><ul><li>入社にともない、雇用契約締結、入社情報の登録が必要です。</li><li>法定条項として、入社前健康診断の受診結果が必要となります。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">雇用契約締結</div><div>入社前にContractS経由で雇用契約書が届きますので、内容確認の上契約締結をお願いいたします。</div><div className="numbering-title">入社情報登録</div><div>人事部より入社情報登録のご案内をいたします。<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて入力・ご登録いただきます。</div><div className="numbering-title">入社前検診受診</div><div>入社前に健康診断の受診が必要となりますので、お近くの医療機関で「入社前健康診断」を受診お願いいたします。税込1万円までは会社が負担いたしますので、診断結果と領収証をセットで人事までお渡しください。</div><div className="numbering-title">入社日に出社</div><div>入社当日に、会社メールアドレス宛にジンジャー勤怠ログイン情報が届いているのを確認し、打刻をお願いいたします。</div></div></div>
              {/* 結婚 */}
              <div className="contentTwo"><h3 className="icon-title type-pencil" id="chapter09">結婚</h3><h4 className="bg-title mt-small">結婚された場合</h4><p className="mb-4">ご結婚おめでとうございます。お二人の門出を心からお祝いいたします！</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>ご結婚にともない、結婚祝金の申請をしてください。慶弔金規程により10万円が支給されます。</li><li>入籍後、転居や氏名変更、扶養追加等があった場合は、<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて各種申請をお願いいたします。</li><li>結婚（入籍）された場合、特別休暇が5日付与されます。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">慶弔金（結婚祝金）申請</div><div><p>慶弔金規程に伴い、10万円が支給されます。<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて慶弔金支給申請をお願いいたします。タレントパレットで申請書の承認後に、2週間以内に給与支給口座に振り込まれます。※経費精算と同じタイミングでの処理となります。</p></div><div className="numbering-title">社員情報変更登録</div><div><p><a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて各種申請をお願いいたします。転居や氏名変更、扶養追加等があった場合は、公的書類（3カ月以内に取得した住民票、マイナンバーカード 等）を添付していただく必要がございます。</p></div><div className="numbering-title">慶弔休暇の付与</div><div><p>結婚（入籍）の場合、特別休暇として5日間付与されます（正社員のみ）。休暇取得は<a href="https://kintai.jinjer.biz/" target="_blank">ジンジャー勤怠</a>にて申請をお願いいたします。</p></div></div></div>
              {/* 出産・子育て */}
              <div className="contentThree"><h3 className="icon-title type-pencil" id="chapter10">出産・子育て</h3><h4 className="bg-title mt-small">出産された場合</h4><p className="mb-4">お子様のお誕生、おめでとうございます！！<br />お子様の健やかな健康を心からお祈りいたします。</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>お子様誕生にともない、出産祝金の申請をしてください。慶弔金規程により10～30万円が支給されます。</li><li>出産後、扶養追加等がある場合は<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>より申請をお願いいたします。</li><li>奥様が出産された場合、特別休暇が1日付与されます。</li><li>育児休業、育児短時間勤務をご希望の場合は、別途申請が必要となります。</li>
                <li>乳幼児～小学校3年生の児童を育てているご家庭でご利用いただける「ベビーシッター割引券」（企業主導型内閣府ベビーシッター利用支援事業）を配布しております。ご希望の方は人事部までご相談ください。<br />※詳細は福利厚生＞子育て支援＞ベビーシッター割引券配布のページをご確認ください。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">慶弔金（出産祝金）申請</div><div><p>慶弔金規程に伴い、10～30万円が支給されます。<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて慶弔金支給申請をお願いいたします。出産祝金：1人目10万円→2人目20万円→3人目以降都度30万円<br />※2022/4/1以降入社の社員は「入社後1年以上」という在籍条件が付きます。<br />楽楽精算で申請書の承認後に、2週間以内に給与支給口座に振り込まれます。<br />※経費精算と同じタイミングでの処理となります。</p></div><div className="numbering-title">社員情報変更登録</div><div><p>人事部より入社情報登録のご案内をいたします。タレントパレットにて入力・ご登録いただきます。なお、お子様を扶養に入れる場合は、健康保険証作成のため「社員本人とお子さんそれぞれのマイナンバー」が必要となります。</p></div><div className="numbering-title">慶弔休暇の付与（男性社員のみ）</div><div><p>配偶者が出産した場合、特別休暇として1日付与されます（正社員のみ）。休暇取得は<a href="https://kintai.jinjer.biz/" target="_blank">ジンジャー勤怠</a>にて申請をお願いいたします。</p></div><div className="numbering-title">育児休業（育休）申請</div><div><p>産後休暇（産休）後に、1歳に満たない子を養育する場合、育児休業の取得が可能です。産後休暇の翌日（男性社員の場合は出産日）から1歳の誕生日を迎える前日までが休業期間となり、保育所への入所ができない場合は半年～1年の延長が可能となっています。<br />取得を希望する場合、上長との相談の後、人事部労務チームにご連絡ください。</p>



                  <div className="todo-list-border mb-3">
                    <div className="todo-list mb-2">
                      <span>CHECK</span>Zenkenでは、男性の育児休業の取得実績があります！
                    </div>
                    <p>男性の育児休業とは
                      <br />「産後パパ育休」「育児休業」の２種類があります。
                      <br />「産後パパ育休」は、お子さんの出産日から８週間以内に４週間まで取得可能です（２回まで分割取得可能）。通常の育児休業と併用できます。
                      <br />「育児休業」は、女性の場合と同様に１歳に満たない子を養育する場合、１歳の誕生日を迎える前日まで休業をすることができます。
                    </p>
                  </div>


                  <h4 className="bg-title mt-small">産後パパ育休・育児休業申請　お手続きの流れ</h4>

                </div></div></div>
              <div className="numbering-wrap type-step">
                <div className="numbering-title">産後パパ育休・育児休業取得の意思を上長に伝える</div>
                一番悩むところかもしれませんが、大丈夫。先延ばしにしてもいいことは全くありませんし、なるべく早めにお伝えください。
                <div><p className="numbering-title">取得について人事より説明を受ける</p>説明後、ご不明な点は遠慮なくご確認ください。</div><div><p className="numbering-title">申請をする</p>人事から受け取った「育児休業取得申請書」に必要事項記入後、上長宛に申請書をご提出ください。</div><div><p className="numbering-title">産後パパ育休・育児休業スタート</p>育児休業からの復職後、小学校6年生までの子を養育する場合、育児短時間（時短）勤務が可能です。時間短縮は最大2時間までとなります。時短を希望する場合、上長との相談の後、人事部労務チームにご連絡ください。</div><div><p className="numbering-title">育児短時間勤務（時短）申請</p>引継ぎ等を終えたら、あとは会社のことは気にせず、育児休業をスタートさせましょう！</div>



              </div>
              {/* マイホーム購入 */}
              <div className="contentFour"><h3 className="icon-title type-pencil" id="chapter11">マイホーム購入</h3><h4 className="bg-title mt-small">マイホームを購入された場合</h4><p className="mb-4">新居のご購入おめでとうございます！！<br />これからの生活が一層楽しみなものになりますね！</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>マイホーム購入、転居等があった場合、人事へご連絡ください。住所変更は<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>より申請をお願いいたします。</li><li>通勤費の清算は定期代支給、IC料金支給によって処理が異なります。</li><li>定期区間の登録は「楽楽精算」でも必須となります。</li><li>住宅ローンの借入れを行った場合、初年度の年末調整は行いますが、別途ご自身で確定申告が必要となります。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">社員情報変更登録</div><div><a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて各種申請をお願いいたします。転居に伴い、3カ月以内に取得した住民票を添付し住所変更申請をしていただく必要がございます。</div><div className="numbering-title">通勤費（定期代・IC料金）精算</div><div><p>住所の変更日が、1日か月途中かにより定期代の変更月が異なります。1日変更の場合はその月から、月度途中の場合は翌月から変更となります。半年定期代で支給されている場合、上記変更月から残り月数の新・旧定期代差分を精算し、変更月度の給与にて支給または控除となります。<br />なお、時給契約社員等、出勤日数にて通勤費を支給している社員の場合、変更日までを旧IC料金、変更日以降から新IC料金で計算して支給いたします。</p><p>※転居の際の定期区間登録は、楽楽精算でも必須となります。ジンジャーとはリンクしておりませんので、<a href="https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/" target="_blank">楽楽精算ログイン</a>&gt;個人設定&gt;定期区間にて変更手続きを行ってください。</p></div><div className="numbering-title">（住宅ローン対象者のみ）初年度：ご自身で確定申告</div><div>通常通り年末調整を会社で行いますが、住宅ローン初年度は、最寄りの税務署に会社発行の源泉徴収票持参の上、ご自身で確定申告を行っていただきます。その際に「年末調整のための（特定増改築等）住宅借入金等特別控除証明書」が発行されますので、大事に保管をお願いいたします。</div><div className="numbering-title">（住宅ローン対象者のみ）2年目以降：会社で年末調整</div><div>前年度に税務署で発行された「年末調整のための（特定増改築等）住宅借入金等特別控除証明書」の該当年度分と、金融機関から毎年発行される「住宅取得資金に係る借入金の年末残高等証明書」を合わせて年末調整の際にご提出ください。</div></div></div>
              {/* 引越し */}
              <div className="contentSeven">
                <h3 className="icon-title type-pencil" id="chapter12">引越し</h3>
                <h4 className="bg-title mt-small">引越しされた場合</h4>
                <p className="mb-4">心機一転、新たな地でのリスタートですね。
                  <br />新しいホームタウンがよい街でありますように！
                </p><div className="todo-list-border mb-3">

                  <div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div>
                  <ul><li>転居された場合、タレントパレットの承認フロー
                    <a href="https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=0d2c5e9aa7274a9ab8d1cfa3a3bfe828" target="blank" className="text-link type-external">「住所変更申請」</a>
                    にて申請をお願いいたします。</li>
                    <li>通勤費の清算は定期代支給、IC料金支給によって処理が異なります。</li>
                    <li>定期区間の登録は「楽楽精算」でも必須となります。</li>
                  </ul>
                </div>

                <h4 className="bg-title" id="chapter06">お手続きの流れ</h4>
                <div className="numbering-wrap type-step">
                  <div className="numbering-title">社員情報変更登録</div>
                  <div>
                    <p>タレントパレットの承認フロー
                      <a href="https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=0d2c5e9aa7274a9ab8d1cfa3a3bfe828" target="blank" className="text-link type-external">「住所変更申請」</a>にて申請をお願いいたします。</p>
                    <div className="todo-list-border mb-3">
                      <div className="todo-list mb-2"><span className="attention-point">注意点</span></div>
                      <p>通勤経路は、内部監査による調査が行われます。申請内容と異なるルートで定期券を購入をされた場合、厳重な指導を受けることになりますので十分にご注意ください。</p>
                      <ul>
                        <li>会社最寄り駅をご入力ください。<br />（例：東京オフィスの場合）電車であれば「神谷町」または「六本木一丁目」、バスであれば「麻布台ヒルズ」「虎ノ門五丁目」「飯倉片町」</li>
                        <li>最も経済的または合理的な通勤経路を選択してください。特別な事情があってイレギュラーな通勤経路を申請する場合は、補足事項に必ず理由を記載してください。</li>
                        <li>定期区間の登録は「楽楽精算」でも必須となります。</li>
                        <li>乗換案内のキャプチャは「IC料金が分かる画面」と「1・3・6ヶ月定期代が分かる画面」のアップロードをお願いします。</li>
                      </ul>
                    </div>



                  </div><div className="numbering-title">通勤費（定期代・IC料金）精算</div><div><p>住所の変更日が、1日か月途中かにより定期代の変更月が異なります。1日変更の場合はその月から、月度途中の場合は翌月から変更となります。半年定期代で支給されている場合、上記変更月から残り月数の新・旧定期代差分を精算し、変更月度の給与にて支給または控除となります。<br />なお、時給契約社員等、出勤日数にて通勤費を支給している社員の場合、変更日までを旧IC料金、変更日以降から新IC料金で計算して支給いたします。</p><p>※転居の際の定期区間登録は、楽楽精算でも必須となります。ジンジャーとはリンクしておりませんので、<a href="https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/" target="_blank">楽楽精算ログイン</a>&gt;個人設定&gt;定期区間にて変更手続きを行ってください。</p></div></div></div>



              {/* 休職・復職 */}
              <div className="contentTen"><h3 className="icon-title type-pencil" id="chapter13">休職・復職</h3>
                {/* <div className="mt-4 row">
                  <div className="col-sm-6"><a className="btn main-btn type-internal">休職</a></div>
                  <div className="col-sm-6"><a className="btn main-btn type-internal">復職</a></div>
                </div> */}
                <h4 className="bg-title mt-small">休職</h4><p className="mb-4">体調が優れない・・・<br />主治医の先生から休業する様に言われました。</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>申請手続きをお願いいたします</div><ul>
                  <li>所属長、または人事部労務チームへ連絡してください。</li>
                  <li>病気や負傷等(私傷病)で休む場合、診断書を会社へ提出してください。</li>
                  <li>休職に関する詳しい説明は<a href="https://drive.google.com/file/d/15pBZhLfB9hlnW8QABAFaesAH1EE3v1H-/view?usp=drive_link" target="blank" className="text-link type-external">こちら</a>からご確認いただけます</li>
                </ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">連絡</div><div><p>所属長、または人事部労務チームへ連絡をしましょう!</p></div><div className="numbering-title">診断書の提出</div><div><p>主治医から病状と療養見込み期間記載の診断書を会社へ提出してください。<br /><span>　</span>※提出は郵送、またはご家族が持参されてもよいです。<br /><span>　</span>※休職前に産業医との面談をご希望の場合、面談の設定も可能です。</p></div><div className="numbering-title">ゆっくり休養</div><div><p>休業中に連絡する担当者を確認し、まずはゆっくり休養しましょう。<br /><span>　</span>※休業中は、週1回または月1回の連絡をいれましょう。<br /><span>　</span>(ご自身が連絡できない場合は、家族から連絡をされても構いません)<br /><span>　</span>※担当者からも連絡がありますので、状況を伝えましょう。</p></div></div><h4 className="bg-title" id="chapter06">休職中の気になる事</h4><div className="numbering-wrap type-step"><p className="contents__qa--question no-acd no-acd content-one-q">お給料はどうなるの?</p><p className="catch">欠勤をすると給与の支払いはありません。</p><ul><li>傷病手当金支給申請があります(連続して3日以上休んでいる健康保険加入者)<br /><span>　</span>支給額は1日につき、標準報酬月額の2/3に相当する金額です。<br /><span>　</span>同一の傷病について、支給を開始した日から最長1年6ヵ月間です。</li></ul><div><p>注1　傷病手当金支給申請書は主治医証明、本人記載欄を記入したものをご提出ください。<br /><span>　　</span>会社から協会けんぽへ提出します(指定したご自身の口座に手当金が振込まれます)</p><p>注2　社会保険料、住民税等の支払が発生します、会社が立て替えていますので、休業中毎月支払うか<br /><span>　　</span>復職後まとめて払う等の計画的な支払方法を人事部労務チームと相談しましょう。</p></div><p className="contents__qa--question no-acd no-acd content-one-q">有給休暇は使えるの? </p><p className="catch">取得は可能ですが、傷病手当金の対象外になります。</p><ul><li>傷病手当金の支給対象日は待機期間の3日後です、有給休暇を使用すると、待機期間が再度発生します。<br /><span>　</span>有給の活用として、復職後の通院等の為に残しておく事をお奨めします。</li></ul><p className="contents__qa--question no-acd no-acd content-one-q">いつまで休めるの?</p><p className="catch">在職期間により休める期間は就業規則に定められています</p><ul><li>休業期間は就業規則に記載されていますので、休み始めに確認しておきましょう。</li></ul><p className="contents__qa--question no-acd no-acd content-one-q">仕事はどうなるんだろう?   休んでも大丈夫?　回るだろうか?</p><ul><li>休業すると申し訳ない気持ちから「会社を辞めたい」と思う様になりやすいです。<br />正しい判断力のない状態と言えますので、判断力が回復してからよく考えましょう。</li><li>仕事は周りが助けてくれますが、病気はご自身で改善するしかありません、まずは休養を最優先にしましょう。</li><li>仕事の引継ぎや問い合わせ等で、当初2週間位は落ち着かない事が多いので、職場を離れて<br /><span>　</span>消耗したエネルギーの回復に、休業期間を主治医と相談して十分取りましょう。</li></ul><h4 className="bg-title mt-small">復職</h4><p className="mb-4">体調が回復したので働きたい!<br />主治医から復職許可をいただきました。</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>所属長、または人事部労務チームへ連絡してください。</li><li>主治医による職場復帰可能の判断が必要です。復職可能の診断書を会社に提出してください。</li><li>産業医との面談を受けていただきます。</li><li>主治医の診断書と産業医の意見書を基に、復職プランを作成します。</li>
                  <li>復職に関する詳しい説明は<a href="https://drive.google.com/file/d/15pBZhLfB9hlnW8QABAFaesAH1EE3v1H-/view?usp=drive_link" target="blank" className="text-link type-external">こちら</a>からご確認いただけます</li>
                </ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">連絡</div><div><p>所属長、または人事部労務チームへ連絡をしましょう。</p></div><div className="numbering-title">診断書の提出</div><div><p>主治医からの復職可能の診断書を提出してください。<br /><span>　</span>※就業規則等あれば診断書に記載していただいてください。<br /><span>　</span>※可能な範囲で生活記録票を付けてください。</p></div><div className="numbering-title">産業医との面談</div><div><p>産業医面談を受けていただきます。</p></div><div className="numbering-title">復職プランの作成</div><div><p>主治医の診断書と産業医の意見書を基に、会社が復職の可否を判断します。<br /><span>　</span>※復職が認められなかった場合は、休職期間が延長されます。</p><ul><li>復職可能・・・復職に向けたプランを作成します。まずは通勤訓練から始めましょう。</li><li>復職不可・・・引き続き休職をしていただきます。</li></ul></div></div></div></div>
              {/* 退職 */}
              <div className="contentFive"><h3 className="icon-title type-pencil" id="chapter14">退職</h3><h4 className="bg-title mt-small">退職される場合</h4><p className="mb-4">これまで大変お世話になりました。<br />新天地でのご活躍を祈念しております。</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>退職が決まった場合、退職関連の書類を人事宛にご提出いただきます。</li><li>社員持株会の会員は、持株会事務局まで事前にお問い合わせください。（担当者は<a href="/welfare">福利厚生</a>ページからご確認ください）</li><li>選択制DC加入者は、DC事務局（人事部 人事労務チーム）までお問い合わせください。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">退職書類の提出</div><div><p>以下をご提出いただきます。</p><ol><li>退職届（会社指定用紙）</li><li>退職時の守秘義務に関する誓約書</li><li>時間外勤務確認書</li><li>証明書発行願い　※社会保険資格喪失証明書や退職書類等、会社発行の証明書が必要な場合</li></ol></div><div className="numbering-title">退職時にご返却いただくもの</div><ol><li>社員証　※勤務最終日の翌日以降</li><li>健康保険被保険者証（保険証）</li></ol><div className="numbering-title">退職前に手続きが必要なもの</div><div><p>持株会：退職されると持株会員としての資格を失いますので、持株会事務局までお知らせください。退会書類受理後、退会手続きを行います。手続き後、売買単位（100株）の株式は、会員口座へ振替を行います。売買単位未満の株式は、以下のいずれかの処理となります。</p><ol><li>時価で売却し現金で受け取る</li><li>100株に達する臨時拠出を行い（足りない分を現金入金）会員口座へ振替</li></ol></div><div className="numbering-title">退職後に手続きが必要なもの</div><div><p>選択制DC：60歳までは預け入れた掛金は受け取れないため、以下のいずれかの処理を行っていただきます。</p><ol><li>転職先がDCを導入していれば、転職先で移換手続きを行ってください。</li><li>転職先がDCを導入していない場合、個人型確定拠出年金（iDeCo）に移換し資産運用を継続してください。</li></ol></div></div></div>
              {/* 家族の就職・退職 */}
              <div className="contentEight"><h3 className="icon-title type-pencil" id="chapter15">家族の就職・退職</h3><h4 className="bg-title mt-small">ご家族が就職／退職された場合</h4><p className="mb-4">ご家族に変化が訪れるタイミング。<br />リスタートに向けて応援のし甲斐がありますね。</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>ご家族を扶養から外される場合、または扶養に追加する場合は<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>より申請をお願いいたします。</li><li>ご家族を扶養から外す場合は保険証の返却が必要となります。また、ご家族を扶養に追加する場合は、後日保険証が届きます。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">社員情報変更登録</div><div><a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>より申請をお願いいたします。なお、ご家族をご自身の扶養に追加する場合は、健康保険証作成のため「社員本人と被扶養者となる方それぞれのマイナンバー」が必要となります。</div><div className="numbering-title">保険証の返却／お届け</div><div>ご家族を扶養から外す場合、保険証の返却が必要となります。人事に返却いただければ、日本年金機構経由で協会けんぽへ返却いたします。<br />また、ご家族を扶養に入れる場合は保険証が作成されますが、お手元に届くまでに2週間程度かかります。</div></div></div>
              {/* 介護 */}
              <div className="contentNine"><h3 className="icon-title type-pencil" id="chapter16">介護</h3><h4 className="bg-title mt-small">身内の介護が必要となった場合</h4><p className="mb-4">お世話になっていた側からお世話する側へ。<br />会社として手助けできることをお伝えいたします。</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>要介護状態により異なりますが、ご家族の介護が必要となった場合は人事にお知らせください。</li><li>介護休暇（無給）は要介護者1名につき年5日まで利用できます。介護休暇は時間休も可能。</li><li>介護休業、介護短時間勤務をご希望の場合は、別途申請が必要となります。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">介護休暇申請</div><div><p>2週間以上にわたり常時介護を必要とする家族を介護する場合、介護休暇の取得が可能です。対象者1名につき年5日まで（2名の場合は年10日まで）取得できますが、無給です。介護休暇は1時間単位の取得が可能となっています。休暇取得は<a href="https://kintai.jinjer.biz/" target="_blank">ジンジャー勤怠</a>にて申請をお願いいたします。</p></div><div className="numbering-title">介護休業申請</div><div><p>申請は人事から受け取った「介護休業取得申請書」に必要事項をご記入いただき、<a href="https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/" target="_blank">楽楽精算</a>&gt;ワークフロー&gt;人事稟議書に添付して申請してください。</p></div><div className="numbering-title">介護短時間勤務申請</div><div><p>介護休業からの復職後も家族の介護を行う場合、介護短時間（時短）勤務が可能です。時間短縮は最大2時間までとなります。申請は人事から受け取った「介護短時間勤務申出書」に必要事項をご記入いただき、<a href="https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/" target="_blank">楽楽精算</a>&gt;ワークフロー&gt;人事稟議書に添付して申請してください。</p></div></div></div>
              {/* 身内の不幸 */}
              <div className="contentTen"><h3 className="icon-title type-pencil" id="chapter17">身内の不幸</h3><h4 className="bg-title mt-small">ご家族/ご親族に不幸があった場合</h4><p className="mb-4">この度はお悔やみ申し上げます。<br />会社にできることをお伝えいたしますね。</p><div className="todo-list-border mb-3"><div className="todo-list mb-2"><span>To Do</span>各種申請手続きをお願いいたします</div><ul><li>ご逝去にともない、弔慰金の申請をしてください。続柄により慶弔金規程にともない慶弔金が支給されます。</li><li>ご逝去後、転居や氏名変更、扶養変更があった場合は<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて各種申請をお願いいたします。</li><li>不幸があった場合、続柄により特別休暇が1～7日付与されます。</li></ul></div><h4 className="bg-title" id="chapter06">お手続きの流れ</h4><div className="numbering-wrap type-step"><div className="numbering-title">慶弔金（死亡弔慰金）申請</div><div><p>慶弔金規程に伴い、1～3万円が支給されます。<a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて慶弔金支給申請をお願いいたします。</p></div><div className="numbering-title">社員情報変更登録</div><div><p><a href="https://tvyj3455.talent-p.net/" target="blank" className="text-link type-external">タレントパレット</a>にて各種申請をお願いいたします。</p></div><div className="numbering-title">慶弔休暇の付与</div><div><p>身内に不幸があった場合、特別休暇として1～7日付与されます（正社員のみ）。休暇取得は<a href="https://kintai.jinjer.biz/" target="_blank">ジンジャー勤怠</a>にて申請をお願いいたします。</p></div></div></div>
            </div>
          ) : (
            <></>
          )}
          {/* 人事・勤怠システム*/}
          {explanationChangeValue === "3" ? (
            <div className="contentOne row-12"><h2 className="tag-title">人事・勤怠システム</h2>
              <Row className="toc-btnArea">
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter21"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    承認経路の使い分け
                  </Link>
                </Col>
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter22"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    ジンジャーの使い方
                  </Link>
                </Col>
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter23"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    タレントパレットの使い方
                  </Link>
                </Col>
              </Row><h3 className="icon-title type-pencil" id="chapter21">承認経路の使い分け</h3><p>2025年6月末時点まで、以下の承認経路になっております。</p>              <div className="img-wrap ct">
                <div className="flame">
                  <img
                    src={process.env.PUBLIC_URL + '/jinji_pic/jinnji-hyou.png'}
                    alt="人事のシステムの区分け"
                    className="img-wrap__img"
                  />
                </div>
              </div>
              <h3 className="icon-title type-pencil" id="chapter22">ジンジャーの使い方</h3>
              <h4 className="bg-title mt-small">そもそもジンジャーとは？</h4>
              <p>日々の出退勤の登録や、勤怠（リモートワークのスケジュール登録や打刻修正など）に関わる申請を行うシステムです。</p>
              <h4 className="bg-title mt-small">ジンジャーの使い方</h4>
              <p>使い方がわからないときには、<a href="https://jinjer-kintai.zendesk.com/hc/ja" target="_blank" rel="noopener noreferrer" className="text-link type-external">ジンジャー公式のヘルプページ</a>をご確認ください。<br />それでもわからない場合には、人事労務チームまでご連絡ください。</p>
              <h5 className="icon-title mt-small" id="chapter24">ログイン方法が知りたい</h5>
              <p id="1" className="contents__qa--question no-acd content-one-q">ジンジャーにログインするには？</p>
              <div className="contents__qa--answer kintai"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900002000063" target="_blank" rel="noopener noreferrer" className="text-link type-external">従業員画面へのログイン方法と画面の概要説明</a><p><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/4405208601113" target="_blank" rel="noopener noreferrer" className="text-link type-external">ジンジャーにログインができません</a></p></div>

              <div>
                <h5 className="icon-title mt-small" id="chapter25">パスワード変更が知りたい</h5>
                <p id="1" className="contents__qa--question no-acd content-one-q">パスワードを変更するには？</p>
                <div className="contents__qa--answer kintai"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900002009483" target="_blank" rel="noopener noreferrer" className="text-link type-external">パスワードの変更方法</a><p><a target="_blank" rel="noopener noreferrer" className="text-link type-external"></a></p></div>
              </div>

              <h5 className="icon-title mt-small" id="chapter26">給与明細の確認方法が知りたい</h5>
              <p id="1" className="contents__qa--question no-acd content-one-q">Web明細を確認するには？</p>
              <p className="contents__qa--answer kintai">「<a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900002009483" target="_blank" rel="noopener noreferrer" className="text-link type-external">給与明細画面</a><a target="_blank" rel="noopener noreferrer" className="text-link type-external"></a>」にログインしてご確認ください。</p>
              <p>「PDF」は印刷または添付用のデータとなり、画面のみで確認したい場合は「HTML」をクリックしてご確認ください。<br />賞与明細及び源泉徴収票も、同じ画面でご確認いただけます。</p>
              <h5 className="icon-title mt-small" id="chapter27">こんなとき、どうしたらいい？</h5>
              <p id="1" className="contents__qa--question no-acd content-one-q">申請状況を確認するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900002014046" target="_blank" rel="noopener noreferrer" className="text-link type-external">申請一覧の確認方法</a><a target="_blank" rel="noopener noreferrer" className="text-link type-external"></a></p>
              <p id="1" className="contents__qa--question no-acd content-one-q">申請を取り消すには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360036181092" target="_blank" rel="noopener noreferrer" className="text-link type-external">申請履歴の確認・申請の取消</a><a target="_blank" rel="noopener noreferrer" className="text-link type-external"></a></p>
              <p id="1" className="contents__qa--question no-acd content-one-q">エラーメッセージが表示されます。</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360037627351" target="_blank" rel="noopener noreferrer" className="text-link type-external">【勤怠】よくあるエラーの原因と対処方法</a><a target="_blank" rel="noopener noreferrer" className="text-link type-external"></a></p>
              <p id="1" className="contents__qa--question no-acd content-one-q">アラートを確認するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360036547731" target="_blank" rel="noopener noreferrer" className="text-link type-external">PCでアラート内容を確認する</a><a target="_blank" rel="noopener noreferrer" className="text-link type-external"></a></p>
              <h5 className="icon-title mt-small" id="chapter28">スマホでも使いたい</h5>
              <p id="1" className="contents__qa--question no-acd content-two-q">スマホで打刻するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360035939452" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマホアプリの打刻方法</a></p>
              <p id="2" className="contents__qa--question no-acd content-two-q">スマホで有休を申請するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900004216543" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマホで休日を申請する</a></p>
              <p id="3" className="contents__qa--question no-acd content-two-q">スマホで打刻を修正するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360036490951" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマホで打刻修正を申請する</a></p>
              <p id="4" className="contents__qa--question no-acd content-two-q">スマホで申請を確認するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360036546751" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマホで申請履歴を確認する/申請を取り消す</a></p>
              <p id="5" className="contents__qa--question no-acd content-two-q">スマホで申請を取り消すには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360036546751" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマホで申請履歴を確認する/申請を取り消す</a></p>
              <p id="6" className="contents__qa--question no-acd content-two-q">スマホで休暇残日数を確認するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/360036185672" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマホで休暇の残日数を確認する</a></p>
              <p id="7" className="contents__qa--question no-acd content-two-q">スマホアプリが起動しません。</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/900001205546" target="_blank" rel="noopener noreferrer" className="text-link type-external">アプリが正常に動作しない場合の対処方法</a></p>
              <p id="8" className="contents__qa--question no-acd content-two-q">アラートを確認するには？</p>
              <p className="contents__qa--answer"><a href="https://jinjer-kintai.zendesk.com/hc/ja/articles/4405077604633-%E3%82%B9%E3%83%9E%E3%83%9B%E3%82%A2%E3%83%97%E3%83%AA%E3%81%A7%E3%81%AE%E3%82%A2%E3%83%A9%E3%83%BC%E3%83%88%E7%A2%BA%E8%AA%8D%E6%96%B9%E6%B3%95" target="_blank" rel="noopener noreferrer" className="text-link type-external">スマホアプリでのアラート確認方法</a></p>

              <h3 className="icon-title type-pencil" id="chapter23">タレントパレットの使い方</h3>
              <h4 className="bg-title mt-small">そもそもタレントパレットとは？</h4>
              <p>人事情報（住所変更や異動申請など）に関わる申請やアンケートが実施されるシステムです</p>

              <h4 className="bg-title mt-small">タレントパレットの使い方</h4>
              <p>使い方がわからないときには、<a href="https://www.pa-solution.net/as/scope3/tpfaq/web/Default.aspx?dispnodeId=4&account=tvyj3455&name=Zenken%e6%a0%aa%e5%bc%8f%e4%bc%9a%e7%a4%be" target="_blank" rel="noopener noreferrer" className="text-link type-external">タレントパレット公式のヘルプページ</a><br />それでもわからない場合には、人事労務チームまでご連絡ください。</p>

              <iframe src="https://docs.google.com/presentation/d/1O2Z_G9uQGD1vRoAjkUAJaNsaVhoWBw58CkRbYu6HJrA/preview?slide=id.p" width="860" height="520" allow="autoplay"></iframe>

            </div>
          ) : (
            <></>
          )}
          {/* ヘルスケア*/}
          {explanationChangeValue === "4" ? (
            <div className="contentThree">
              <h2 className="tag-title">ヘルスケア</h2>
              <Row className="toc-btnArea">
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter18"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    外部相談窓口サービス［アンリ］
                  </Link>
                </Col>
                <Col sm={4} className='toc-btn'>
                  <Link
                    to="chapter20"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    健診
                  </Link>
                </Col>
                {/* <Col sm={3} className='toc-btn'>
                  <Link
                    to="chapter21"
                    smooth={true}
                    duration={500}
                    offset={-100}
                    className='btn main-btn type-internal w-100'
                  >
                    相談窓口
                  </Link>
                </Col> */}
              </Row>
              {/* 外部相談窓口サービス［アンリ］ */}
              <div className="contentTwo"><h3 className="icon-title type-pencil" id="chapter18">外部相談窓口サービス［アンリ］</h3><p>仕事や人間関係の悩み、会社に相談できないこともアンリなら無料で気軽に相談できます。<br />なお、相談した内容は会社には秘密にできます。</p>
                <div className="mb-4 row">
                  {/* <div className="col-sm-6"><a className="btn main-btn type-internal">外部相談窓口サービス［アンリ］</a></div> */}
                </div><h4 className="bg-title mt-small"> 外部相談窓口サービス［アンリ］とは？</h4><div className="d-flex flex-wrap-area justify-content-between"><div className="flex-fill no-link-btn p-3">匿名で相談可能</div><div className="flex-fill no-link-btn p-3">家族のことも相談可能</div><div className="flex-fill no-link-btn p-3">会社には詳細報告なし</div></div><div className="">相談員は保健師、精神保健福祉士、公認心理士、管理栄養士、保育士といったすべて国家資格保有者です。育児のことも相談できます。</div><h4 className="bg-title">【アンリ】 ご利用の流れ</h4><div className="numbering-wrap type-step"><h5 className="numbering-title">外部相談窓口アンリにアクセスする</h5><p><a href="https://doctor-trust.co.jp/hokenshi/anri/anri-sp.html" target="_blank" className="text-link type-external">こちら</a>よりアクセスしてください。どういった方が担当してくれるのかもサイト上で確認できますので、安心です。<br />※アクセスに必要な事業所番号は【9720-3461】となります。</p><h5 className="numbering-title">電話、メール、Zoom面談で相談する</h5><p>電話（平日10～18時）、メール（24時間受付）、Zoom面談（平日10～20時）の3通りからお選びいただけます。</p><h5 className="numbering-title">繰り返しや家族の相談も可能</h5><p>1回の相談では解決できない悩みも、繰り返し相談することで解決の糸口が見えてくることも。<br />ご家族のことも相談できますので、幅広くご利用いただけます。</p></div></div>
              {/* 健診 */}
              <div>
                <h3 id="chapter20" className="icon-title type-pencil">健診</h3>
                <p>対象者の方は法令により受診が義務付けられております！<br />Zenkenとして、皆さんを健康な状態で働かせるという「安全配慮義務」があります。<br />実施期間内に必ず受診いただきますようお願いいたします。</p>
                <p>～～～<br />2025年度 健康診断は準備中です。<br />時期になりましたら、お知らせいたします！<br />～～～</p>
                <p>【健康経営推進隊より お役立ちコラム】<br />次回の健康診断を前に、食生活に関するコラム「<a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2432" className="text-link" target="_blank">健康診断に備えて‥‥食事に気をつけましょう🌻🌞</a>」をアップしています。<br />いまから対策すれば、健康診断に間にあうかも！！<br />是非お読みいただき、ご自身の食生活を見直してみては？</p>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div >
      <Footer />
    </>
  );
}
export default JinjiLifestyle;
